// src/Homepage.tsx
import React from 'react';
import Header from '../Header';
import HeroSection from '../homepage/Hero';
import FeaturesSection from '../homepage/FeaturesSection';
import StatsSection from '../homepage/StatsSection';
import TestimonialsSection from '../homepage/Testimonials';
import CTASection from '../homepage/CTASection';
import AboutUs from "../homepage/AboutUs";
import IntroductionSection from "../homepage/IntroductionSection";
import Recenzie from "../homepage/Recenzie";
import BlogSection from "../homepage/BlogSection";
import CennikSection from "../homepage/CennikSection";
import WhyPsychiatriSection from "../homepage/WhyPsychiatriSection";
import {useNavigate} from "react-router-dom";

const Homepage: React.FC = () => {
    return (
        <div>
            <HeroSection/>
            <AboutUs />
            <BlogSection />
            <WhyPsychiatriSection />
            <CennikSection />
            <Recenzie />

            <CTASection />
        </div>
    );
};

export default Homepage;
